<template>
	<div class="hero-image">
		<slot>
			<picture>
				<source
					v-if="item.imagePortraitWebp"
					:srcset="item.imagePortraitWebp"
					type="image/webp"
					media="(max-width: 500px)"
				/>
				<source v-if="item.imagePortrait" :srcset="item.imagePortrait" media="(max-width: 500px)" />
				<source :srcset="item.imageWebp" type="image/webp" />
				<source :srcset="item.image" />
				<img class="slider-image" :src="item.image" :alt="item.imageAlt" />
			</picture>
		</slot>
	</div>
</template>

<script setup>
defineProps({
	item: {
		type: Object,
		default: () => ({
			image: '',
			imageWebp: '',
			imageAlt: '',
			imagePortrait: '',
			imagePortraitWebp: '',
			imagePortraitAlt: '',
		}),
	},
	type: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.hero-image {
	width: 100%;
	height: 100%;
	object-fit: cover;
	position: relative;

	&::before {
		content: '';
		display: block;
		position: absolute;
		inset: 0;
		background: rgb(0 0 0 / 20%);
		z-index: 2;
	}

	img {
		object-fit: cover;
		height: 100%;
		width: 100%;
		position: relative;
		z-index: 1;
	}
}
</style>
